import Editor from '@draft-js-plugins/editor';
import createMentionPlugin, { defaultSuggestionsFilter } from '@draft-js-plugins/mention';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import createInlineToolbarPlugin from '@draft-js-plugins/inline-toolbar';
import debounce from 'lodash/debounce';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import css from './CircleBlockEditor.module.css';

import { EditorState, Modifier } from 'draft-js';
import { checkElephantModalOpen } from '../../util/data';

const MAX_CHAR_LIMIT = 4000;
const URL_REGEX = /(https?:\/\/[^\s]+)/;

const CircleBlockEditor = props => {
  const {
    editorState,
    setEditorState,
    advancedSearchData = {},
    onAdvancedSearch,
    replyCommentPlaceHolder = '',
    hasAttachment = false,
    setLimitExceed,
    onSetElephantVerificationModal=()=>{},
    handleCloseFeedModal=()=>{},
    currentUser
  } = props;
  const { records = [] } = advancedSearchData || {};

  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState(defaultSuggestionsFilter('', records));

  //infinit render issue fixed
  const debouncedSetSuggestions = useCallback(
    debounce(newSuggestions => {
      setSuggestions(newSuggestions);
    }, 100),
    []
  );

  useEffect(() => {
    if (records.length === 0) return;

    const newSuggestions = defaultSuggestionsFilter('', records);
    debouncedSetSuggestions(newSuggestions);

    return () => {
      debouncedSetSuggestions.cancel();
    };
  }, [records, debouncedSetSuggestions]);

  const { MentionSuggestions, plugins } = useMemo(() => {
    const mentionPlugin = createMentionPlugin();
    // Initialize the Linkify plugin with custom component
    const linkifyPlugin = createLinkifyPlugin({
      component: props => {
        const { href, children } = props;

        // If it's an email, render as plain text
        if (href.startsWith('mailto:')) {
          return <span>{children}</span>;
        }

        // Render normal links with special color and hover underline
        return (
          <a href={href} className={css.normalLinks} target="_blank">
            {children}
          </a>
        );
      },
    });

    const inlineToolbarPlugin = createInlineToolbarPlugin();
    // eslint-disable-next-line no-shadow
    const { MentionSuggestions } = mentionPlugin;
    // const { InlineToolbar } = inlineToolbarPlugin;
    // eslint-disable-next-line no-shadow
    const plugins = [mentionPlugin, linkifyPlugin, inlineToolbarPlugin];
    return { plugins, MentionSuggestions };
  }, []);

  const onOpenChange = useCallback(_open => {
    setOpen(_open);
  }, []);

  const debouncedSearch = useCallback(
    debounce(searchQuery => {
      onAdvancedSearch({ query: searchQuery });
    }, 500),
    []
  );

  const onSearchChange = value => {
    debouncedSearch(value?.value);
  };

  const onChange = newEditorState => {
    const currentContent = newEditorState.getCurrentContent();
    const currentLength = currentContent.getPlainText('').length;
    setEditorState(newEditorState);
    if (currentLength > MAX_CHAR_LIMIT) {
      setLimitExceed(true);
    } else {
      setLimitExceed(false);
    }
  };

  const replaceSelection = (currentEditorState, text) => {
    const contentState = currentEditorState.getCurrentContent();
    const selectionState = currentEditorState.getSelection();
    const newContentState = Modifier.replaceText(contentState, selectionState, text);
    return EditorState.forceSelection(
      EditorState.push(currentEditorState, newContentState, 'insert-characters'),
      newContentState.getSelectionAfter()
    );
  };

  return (
    <div
      className={hasAttachment ? css.inputAttachmentBoxWrapper : css.inputBoxWrapper}
      onClick={() => {
        const isNotPermission = checkElephantModalOpen(currentUser);
        if (isNotPermission) {
          handleCloseFeedModal();
          onSetElephantVerificationModal(true);
          return;
        }
        ref.current?.focus();
      }}
    >
      {/* <Editor
        className={css.editorBox}
        placeholder={replyCommentPlaceHolder || 'Write something...'}
        editorKey={'editor'}
        editorState={editorState}
        onChange={onChange}
        plugins={plugins}
        ref={ref}
      /> */}
      <Editor
        className={css.editorBox}
        placeholder={replyCommentPlaceHolder || 'Write something...'}
        editorKey={'editor'}
        editorState={editorState}
        onChange={onChange}
        plugins={plugins}
        ref={ref}
        handlePastedText={(text, html, currentEditorState) => {
          if (URL_REGEX.test(text) || !currentEditorState.getSelection().isCollapsed()) {
            onChange(replaceSelection(currentEditorState, text));
            return 'handled';
          }

          return 'not-handled';
        }}
      />
      <MentionSuggestions
        open={open}
        onOpenChange={onOpenChange}
        suggestions={suggestions}
        onSearchChange={onSearchChange}
        onAddMention={item => {
          console.log('item', item);
        }}
      />
    </div>
  );
};

export default CircleBlockEditor;

// {
//   mentionComponent(mentionProps) {
//     return (
//       <span
//         className={mentionProps.className}a
//         // eslint-disable-next-line no-alert
//         onClick={() => alert('Clicked on the Mention!')}
//       >
//         {mentionProps.children}
//       </span>
//     );
//   },
// }
